module.exports = __webpack_public_path__ + "static/media/akshita.8f01714e.JPG";